import CafeteriaTeaboyManagementTable from './lib/table';

import * as S from './styles';
import AppLoading from 'components/appLoading';
import PageTitle from 'components/pageTitle';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

export default function CafeteriaTeaboyManagementPage() {
  const { floorList } = useTypedSelector((state) => state.Floors);
  const { teaboyList, assignToFloor } = useTypedSelector((state) => state.Teaboy);
  const { cafeTeriaStatus } = useTypedSelector((state) => state.Cafeteria);

  return (
    <S.Container>
      {/* The head row this screen drew held the title and nothing else. */}
      <PageTitle title="Teaboy Management" />
      <CafeteriaTeaboyManagementTable data={floorList.data} teaboyList={teaboyList.data} loading={floorList.loading} />

      <AppLoading loading={assignToFloor.loading || teaboyList.loading || cafeTeriaStatus.loading} />
    </S.Container>
  );
}
